/**
 * Converts plain text/markdown or mixed HTML content into properly formatted HTML.
 * - Preserves existing HTML tags (like <p>, <h4>, <ul>, etc.) so they render as formatted elements
 * - Splits by \n into line breaks or paragraphs
 * - Converts markdown lists (- or *) into <ul><li>
 * - Converts ordered lists (1. or 1)) into <ol><li>
 * - Converts **bold** syntax to <strong>
 *
 * @param content The raw text content to format
 * @returns Formatted HTML string ready for Angular sanitization
 */
export function formatContentToHtml(content: string): string {
  if (!content) return '';

  const lines = content.split(/\\n|\n/);
  let html = '';
  let inUl = false;
  let inOl = false;

  const blockTagRegex = /^<\/?(p|h[1-6]|ul|ol|li|div|blockquote|table|thead|tbody|tr|td|th|hr)\b/i;

  for (const line of lines) {
    const trimmed = line.trim();

    const ulMatch = trimmed.match(/^[-*]\s+(.+)/);
    const olMatch = trimmed.match(/^\d+[.)\]]\s+(.+)/);

    if (ulMatch) {
      if (inOl) { html += '</ol>'; inOl = false; }
      if (!inUl) { html += '<ul class="!list-disc">'; inUl = true; }
      html += `<li>${ulMatch[1]}</li>`;
    } else if (olMatch) {
      if (inUl) { html += '</ul>'; inUl = false; }
      if (!inOl) { html += '<ol>'; inOl = true; }
      html += `<li>${olMatch[1]}</li>`;
    } else {
      if (inUl) { html += '</ul>'; inUl = false; }
      if (inOl) { html += '</ol>'; inOl = false; }

      if (trimmed === '') {
        html += '<br>';
      } else if (blockTagRegex.test(trimmed)) {
        html += trimmed;
      } else {
        html += `<p>${trimmed}</p>`;
      }
    }
  }

  if (inUl) html += '</ul>';
  if (inOl) html += '</ol>';

  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  return html;
}

